module.exports = __webpack_public_path__ + "img/dashboard3.a4083d51.png";